import React, { Ref } from 'react';
import map from 'lodash/map';

import styles from './Select.module.scss';

interface ListItem {
  id?: string | number;
  value?: string | number;
  name?: string;
  displayName?: string;
}

interface AdminSelectProps {
  name: string;
  label?: string;
  list: ListItem[];
  selected?: string | number;
  selectLabel?: string;
  handleChange?: React.ChangeEventHandler<HTMLSelectElement>;
  style?: React.CSSProperties;
  disabled?: boolean;
  error?: string;
  propRef?: Ref<HTMLSelectElement>;
  dataRecurly?: string;
}

const AdminSelect: React.FC<AdminSelectProps> = ({
  name,
  label,
  list,
  selected,
  selectLabel,
  handleChange,
  style,
  disabled,
  error,
  propRef,
  dataRecurly,
}) => {
  return (
    <div className={styles.container} style={style}>
      {label && (
        <label className={styles.label} htmlFor={name}>
          {label}
        </label>
      )}
      <select
        id={name}
        className={`${styles.select} ${error ? styles.error : ''}`}
        name={name}
        value={selected}
        onChange={handleChange}
        disabled={disabled}
        ref={propRef}
        data-recurly={dataRecurly}
      >
        {selectLabel && <option value="">{selectLabel}</option>}
        {map(list, (item) => (
          <option key={item.id || item.value} value={item.id || item.value}>
            {item.name ? item.name : item.displayName}
          </option>
        ))}
      </select>
      {error && <p className={styles.errorMessage}>{error}</p>}
    </div>
  );
};

export default AdminSelect;
